var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// src/init-masonry-registry.ts
import { MasonryDriverNodeRenderersRegistry } from "@leagueplatform/masonry";

// src/node-renderers/insight-card-node-renderer.tsx
import * as React from "react";
import { Box } from "@leagueplatform/genesis-commons";
import {
  HighlightCard,
  CalloutBanner
} from "@leagueplatform/web-common-components";
import { ParagraphText } from "@leagueplatform/genesis-core";
import { useInvokeAction } from "@leagueplatform/masonry";
var InsightHighlightCardNodeRenderer = ({
  heading,
  actionText,
  callout,
  onClick,
  items
}) => {
  var _a;
  const invokeAction = useInvokeAction();
  return /* @__PURE__ */ React.createElement(
    HighlightCard,
    {
      title: heading,
      actionLink: (_a = onClick == null ? void 0 : onClick.payload) == null ? void 0 : _a.url,
      onClick: (event) => {
        if (onClick) {
          invokeAction(__spreadValues({
            event
          }, onClick));
        }
      },
      actionText
    },
    /* @__PURE__ */ React.createElement(CalloutBanner, { icon: callout.image, label: callout.imageAltText }, /* @__PURE__ */ React.createElement(ParagraphText, null, callout.body)),
    /* @__PURE__ */ React.createElement(Box, { mt: "two" }, items)
  );
};

// src/node-renderers/horizontal-bar-graph-insight-node-renderer.tsx
import * as React2 from "react";
import {
  InsightCardHorizontalBarGraphV2
} from "@leagueplatform/dashboard";
function generateAriaLabel(items) {
  const ariaLabel = items.map((item) => `${item.label} ${item.displayValue}`).join("; ");
  return ariaLabel;
}
function HorizontalBarGraphNodeRenderer({
  description,
  items
}) {
  const ariaLabel = generateAriaLabel(items);
  return /* @__PURE__ */ React2.createElement(
    InsightCardHorizontalBarGraphV2,
    {
      title: description,
      description: ariaLabel,
      items
    }
  );
}

// src/node-renderers/vertical-bar-graph-insight-node-renderer.tsx
import * as React3 from "react";
import { InsightCardVerticalBarGraphV2 } from "@leagueplatform/dashboard";
function generateAriaLabel2(items) {
  const ariaLabel = items.map((item) => `${item.indexLabel} ${item.indexValue}`).join("; ");
  return ariaLabel;
}
function VerticalBarGraphInsightNodeRenderer({
  description,
  items
}) {
  const ariaLabel = generateAriaLabel2(items);
  return /* @__PURE__ */ React3.createElement(
    InsightCardVerticalBarGraphV2,
    {
      title: description,
      description: ariaLabel,
      items
    }
  );
}

// src/init-masonry-registry.ts
var NODE_TYPE_HORIZONTAL_BAR_GRAPH = "horizontalBarChart";
var NODE_TYPE_VERTICAL_BAR_GRAPH = "verticalBarChart";
var NODE_TYPE_INSIGHT_CARD = "insightCard";
function initMasonryRegistry() {
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "default",
    NODE_TYPE_HORIZONTAL_BAR_GRAPH,
    HorizontalBarGraphNodeRenderer
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "default",
    NODE_TYPE_VERTICAL_BAR_GRAPH,
    VerticalBarGraphInsightNodeRenderer
  );
  MasonryDriverNodeRenderersRegistry.registerRenderer(
    "default",
    NODE_TYPE_INSIGHT_CARD,
    InsightHighlightCardNodeRenderer
  );
}

// src/init-module.ts
import { setDefaultAssets } from "@leagueplatform/asset-config";

// src/asset-map.ts
import leagueLogoIcon from "./assets/league-logo-icon.svg";
import profileAvatar from "./assets/profile-avatar.svg";
import pieLineGraph from "./assets/pie-line-graph.svg";
var ABOUT_ME_ASSETS_MAP = {
  ABOUT_ME_LEAGUE_LOGO_ICON: leagueLogoIcon,
  ABOUT_ME_PROFILE_AVATAR: profileAvatar,
  ABOUT_ME_VIEW_MY_HEALTH_DASHBOARD_BUTTON_ICON: pieLineGraph
};

// src/init-module.ts
var initModule = () => {
  setDefaultAssets(ABOUT_ME_ASSETS_MAP);
};

// src/hooks/use-is-about-me-enabled.ts
import { useFeatureFlagQuery } from "@leagueplatform/user-profile-api";
var ENABLE_ABOUT_ME_WEB = "about_me_web";
var ENABLE_ABOUT_ME_BE = "about_me";
var useIsAboutMeEnabled = () => {
  const { isLoading: isWebLoading, data: isAboutMeWebEnabled } = useFeatureFlagQuery(ENABLE_ABOUT_ME_WEB);
  const { isLoading: isBeLoading, data: isAboutMeBeEnabled } = useFeatureFlagQuery(ENABLE_ABOUT_ME_BE);
  const isAboutMeEnabled = isAboutMeWebEnabled && isAboutMeBeEnabled;
  const isLoading = isWebLoading || isBeLoading;
  return {
    isLoading,
    isAboutMeEnabled
  };
};

// src/about-me.routes.tsx
import * as React10 from "react";
import { Routes, Route, Navigate } from "@leagueplatform/routing";

// src/pages/about-me-landing-page/about-me-landing-page.tsx
import * as React8 from "react";
import { useIntl } from "@leagueplatform/locales";
import {
  useLocationLegacy as useLocation,
  useNavigateLegacy as useNavigate
} from "@leagueplatform/routing";
import { Sidebar } from "@leagueplatform/web-common-components";
import {
  AddAppsDevicesLink,
  HealthProfilePageWrapper,
  MoreOptionsCard
} from "@leagueplatform/health-profile-common";
import { UnavailableDeviceConnectModal } from "@leagueplatform/health-programs";
import {
  ManageUnitsLink,
  AllInsights,
  useIsDashboardEnabled,
  ErrorPanel
} from "@leagueplatform/dashboard";
import {
  RewardsSidebarCard,
  useAchievementsPage,
  UserAchievements,
  useShouldShowRewardsSidebarCard
} from "@leagueplatform/rewards-achievements";
import { Box as Box2, genesisStyled, css } from "@leagueplatform/genesis-commons";

// src/components/account-banner/account-banner.tsx
import * as React4 from "react";
import { useGetUserProfileData } from "@leagueplatform/health-profile-common";
import { HeadingTwo, Flex } from "@leagueplatform/genesis-commons";
import { handleStaticAsset } from "@leagueplatform/asset-config";
import { getContentUrl } from "@leagueplatform/league-content-api";
import { Avatar, Badge } from "@leagueplatform/web-common-components";
import { useRewardsSidebar } from "@leagueplatform/rewards-achievements";
import { StackLayout } from "@leagueplatform/genesis-core";
import { PointsIcon } from "@leagueplatform/rewards-common";
import { LinkLegacy as Link } from "@leagueplatform/routing";
function AccountBanner() {
  const { avatar, preferredFirstName, lastName } = useGetUserProfileData();
  const { userRewardPoints } = useRewardsSidebar();
  const showPointsBadge = userRewardPoints != null;
  const userName = `${preferredFirstName} ${lastName || ""}`;
  return /* @__PURE__ */ React4.createElement(Flex, { alignItems: "center", marginTop: "four", gap: "threeQuarters" }, /* @__PURE__ */ React4.createElement(
    Avatar,
    {
      "data-testid": "avatar",
      imageSrc: (avatar == null ? void 0 : avatar.imageId) ? getContentUrl(avatar == null ? void 0 : avatar.imageId) : handleStaticAsset(
        "ABOUT_ME_PROFILE_AVATAR" /* ABOUT_ME_PROFILE_AVATAR */
      )
    }
  ), /* @__PURE__ */ React4.createElement(StackLayout, { spacing: "$none" }, /* @__PURE__ */ React4.createElement(HeadingTwo, { marginBottom: "half", color: "onSurface.text.primary" }, userName), showPointsBadge && /* @__PURE__ */ React4.createElement(
    Badge,
    {
      as: Link,
      to: "./get-rewarded",
      css: {
        "&:hover": { textDecoration: "underline" },
        backgroundColor: "$surfaceBackgroundSecondary"
      }
    },
    /* @__PURE__ */ React4.createElement(PointsIcon, { value: userRewardPoints })
  )));
}

// src/pages/about-me-landing-page/about-me-landing-page.tsx
import { Tabs } from "@leagueplatform/genesis-core";
import {
  sendAnalyticsPageView,
  trackAnalyticsEvent as trackAnalyticsEvent2,
  EVENT_NAME as EVENT_NAME2
} from "@leagueplatform/analytics";
import {
  LEAGUE_MODULE_NAMES,
  getModulePath
} from "@leagueplatform/league-routes";
import { useDocumentTitle, useSearchParams } from "@leagueplatform/web-common";

// src/pages/about-me-landing-page/sections/about-me-overview.tsx
import * as React7 from "react";
import Masonry, { getMasonryDriver } from "@leagueplatform/masonry";
import { MasonryEngine } from "@leagueplatform/masonry-engine";

// src/constants/masonry.ts
var ABOUT_ME_APP_ID = "about-me-overview";
var HEALTH_REPORT_APP_ID = "health-assessment-report";
var ABOUT_ME_MASONRY_API_VERSION = 1;

// src/widgets/horizontal-bar-graph-insight-widget.tsx
import * as React5 from "react";
import {
  InsightHighlightCard,
  InsightCardHorizontalBarGraph
} from "@leagueplatform/dashboard";
import {
  useGetWidgetData
} from "@leagueplatform/masonry-api";
import { SkeletonBox } from "@leagueplatform/web-common-components";
import { captureError } from "@leagueplatform/observability";

// src/widgets/utils.ts
import { trackAnalyticsEvent, EVENT_NAME } from "@leagueplatform/analytics";
var trackWidgetClickEvent = (metric, insightType) => {
  trackAnalyticsEvent(EVENT_NAME.RESOURCE_CLICKED, {
    product_area: "about me" /* ABOUT_ME */,
    screen_name: `${"about me" /* ABOUT_ME */} ${"overview" /* OVERVIEW */}`,
    resource_type: "insight card" /* INSIGHT_CARD */,
    metric_type: metric,
    insight_type: insightType
  });
};

// src/widgets/horizontal-bar-graph-insight-widget.tsx
function HorizontalBarGraphInsightWidget({
  widget
}) {
  const {
    data: widgetData,
    isLoading,
    error
  } = useGetWidgetData(
    widget,
    ABOUT_ME_MASONRY_API_VERSION
  );
  if (isLoading)
    return /* @__PURE__ */ React5.createElement(SkeletonBox, { width: "100%", height: "120px" });
  if (error) {
    captureError(
      new Error(
        `Unable to fetch widget data for the horizontal bar graph insight widget: ${error}`
      )
    );
  }
  if (error || !widgetData || !(widgetData == null ? void 0 : widgetData.attributes)) {
    return null;
  }
  const { body, callout, cta, heading } = widgetData.attributes;
  return /* @__PURE__ */ React5.createElement(
    InsightHighlightCard,
    {
      heading,
      seeMoreLink: cta,
      callout,
      onClick: () => {
        trackWidgetClickEvent(
          widgetData.attributes.body.metric,
          "horizontal bar graph" /* HORIZONTAL_BAR_GRAPH */
        );
      }
    },
    /* @__PURE__ */ React5.createElement(
      InsightCardHorizontalBarGraph,
      {
        title: body.title,
        description: body.description,
        type: body.metric,
        unit: body.unit,
        items: body.items
      }
    )
  );
}

// src/widgets/vertical-bar-graph-insight-widget.tsx
import * as React6 from "react";
import {
  InsightHighlightCard as InsightHighlightCard2,
  InsightCardVerticalBarGraph
} from "@leagueplatform/dashboard";
import {
  useGetWidgetData as useGetWidgetData2
} from "@leagueplatform/masonry-api";
import { SkeletonBox as SkeletonBox2 } from "@leagueplatform/web-common-components";
import { captureError as captureError2 } from "@leagueplatform/observability";
function VerticalBarGraphInsightWidget({
  widget
}) {
  const {
    data: widgetData,
    isLoading,
    error
  } = useGetWidgetData2(
    widget,
    ABOUT_ME_MASONRY_API_VERSION
  );
  if (isLoading)
    return /* @__PURE__ */ React6.createElement(SkeletonBox2, { width: "100%", height: "120px" });
  if (error) {
    captureError2(
      new Error(
        `Unable to fetch widget data for the vertical bar graph insight widget: ${error}`
      )
    );
  }
  if (error || !widgetData || !(widgetData == null ? void 0 : widgetData.attributes)) {
    return null;
  }
  const { body, callout, cta, heading } = widgetData.attributes;
  return /* @__PURE__ */ React6.createElement(
    InsightHighlightCard2,
    {
      heading,
      seeMoreLink: cta,
      callout,
      onClick: () => {
        trackWidgetClickEvent(body.metric, "vertical bar graph" /* VERTICAL_BAR_GRAPH */);
      }
    },
    /* @__PURE__ */ React6.createElement(
      InsightCardVerticalBarGraph,
      {
        title: body.title,
        description: body.description,
        metric: body.metric,
        unit: body.unit,
        items: body.items
      }
    )
  );
}

// src/hooks/use-is-insights-improvements-enabled.ts
import { useFeatureFlagQuery as useFeatureFlagQuery2 } from "@leagueplatform/user-profile-api";
var ENABLE_INSIGHTS_IMPROVEMENTS = "release_about-me_insights-improvement";
var useIsInsightsImprovementsEnabled = () => {
  const { isLoading, data: isInsightsImprovementsEnabled } = useFeatureFlagQuery2(ENABLE_INSIGHTS_IMPROVEMENTS);
  return {
    isLoading,
    isInsightsImprovementsEnabled
  };
};

// src/pages/about-me-landing-page/sections/about-me-overview.tsx
import { StackLayout as StackLayout2 } from "@leagueplatform/genesis-core";
var MasonryComposer = Masonry.init({
  appId: ABOUT_ME_APP_ID,
  apiVersion: ABOUT_ME_MASONRY_API_VERSION,
  analytics: {
    productArea: "about me" /* ABOUT_ME */,
    screenName: `${"about me" /* ABOUT_ME */} ${"overview" /* OVERVIEW */}`
  },
  customWidgetModules: [
    {
      moduleKey: "dashboard",
      customWidgetDataHooks: {},
      customWidgetsUI: [
        {
          type: "insight_card_horizontal_bar_graph",
          widget: ({ widget }) => /* @__PURE__ */ React7.createElement(HorizontalBarGraphInsightWidget, { widget })
        },
        {
          type: "insight_card_vertical_bar_graph",
          widget: ({ widget }) => /* @__PURE__ */ React7.createElement(VerticalBarGraphInsightWidget, { widget })
        }
      ]
    }
  ]
});
var MasonryOverviewDriver = getMasonryDriver({
  rootNodeId: "aboutMeOverview$root"
});
function AboutMeOverview() {
  const { isInsightsImprovementsEnabled } = useIsInsightsImprovementsEnabled();
  if (isInsightsImprovementsEnabled) {
    return /* @__PURE__ */ React7.createElement(
      StackLayout2,
      {
        orientation: "vertical",
        verticalAlignment: "center",
        horizontalAlignment: "stretch",
        spacing: "$two"
      },
      /* @__PURE__ */ React7.createElement(MasonryEngine, { driver: MasonryOverviewDriver })
    );
  }
  return /* @__PURE__ */ React7.createElement(MasonryComposer.Provider, null);
}

// src/about-me.config.ts
import { isConfigSettled, useConfigSelection } from "@leagueplatform/core";
var defaultConfig = {
  showAccountBanner: true,
  showOptionsMenu: true,
  healthReportMasonryId: void 0,
  showLandingPageBackButton: void 0,
  disableDevicesInMoreOptionsMenu: false
};
var useAboutMeConfig = () => useConfigSelection(
  (config) => isConfigSettled(config) ? {
    showAccountBanner: config.config["flag_about-me_show-account-banner"],
    showOptionsMenu: config.config["flag_about-me_show-options-menu"],
    healthReportMasonryId: config.config["config_about-me_health-report-masonry-id"],
    showLandingPageBackButton: config.config["flag_about-me_show-landing-page-back-button"],
    disableDevicesInMoreOptionsMenu: config.config.config_about_me_disable_devices_menu_option
  } : {},
  defaultConfig
);

// src/pages/about-me-landing-page/about-me-landing-page.tsx
var StyledTab = genesisStyled(Tabs.Tab)(
  css({
    "&[data-selected]": {
      "& span": {
        color: "interactive.action.primary",
        fontWeight: "bold"
      }
    },
    "&:hover": {
      cursor: "pointer"
    },
    textAlign: "center",
    width: "120px",
    paddingX: "four"
  })
);
var tabs = ["overview", "metrics", "achievements"];
function useCurrentTab() {
  const searchParams = useSearchParams();
  const view = searchParams.get("view");
  const currentTab = tabs.includes(view) ? view : "overview";
  return currentTab;
}
function useTabChange() {
  const currentTab = useCurrentTab();
  const wrapperRef = React8.useRef();
  const navigate = useNavigate();
  React8.useEffect(() => {
    var _a, _b;
    window.scrollTo(0, 0);
    (_b = (_a = wrapperRef == null ? void 0 : wrapperRef.current) == null ? void 0 : _a.querySelector(`button[name=${currentTab}]`)) == null ? void 0 : _b.focus();
    sendAnalyticsPageView({
      product_area: "about me" /* ABOUT_ME */,
      screen_name: `${"about me" /* ABOUT_ME */} ${currentTab}`
    });
  }, [wrapperRef, currentTab]);
  const handleOnChange = (tabName) => {
    if (tabs.includes(tabName)) {
      navigate({
        search: `view=${tabName}`
      });
      trackAnalyticsEvent2(EVENT_NAME2.NAVIGATION_TAB_CLICKED, {
        product_area: "about me" /* ABOUT_ME */,
        screen_name: "about me" /* ABOUT_ME */,
        detail: tabName
      });
    }
  };
  return { wrapperRef, handleOnChange };
}
function NavigationTabs() {
  const { $tmap } = useIntl();
  const {
    isFeatureFlagOn: isAchievementsEnabled,
    refetch,
    userAchievementsIsRefetching,
    error
  } = useAchievementsPage();
  const { isDashboardEnabled } = useIsDashboardEnabled();
  const tabsVisible = isDashboardEnabled || isAchievementsEnabled;
  const { wrapperRef, handleOnChange } = useTabChange();
  const currentTab = useCurrentTab();
  const tabMessages = $tmap({
    overview: "OVERVIEW",
    metrics: "METRICS",
    achievements: "ACHIEVEMENTS"
  });
  if (!tabsVisible) {
    return /* @__PURE__ */ React8.createElement(Box2, { paddingTop: "two", paddingBottom: "two" }, /* @__PURE__ */ React8.createElement(AboutMeOverview, null));
  }
  return /* @__PURE__ */ React8.createElement(Box2, { paddingTop: "two", paddingBottom: "two", width: "100%", ref: wrapperRef }, /* @__PURE__ */ React8.createElement(
    Tabs.Root,
    {
      defaultValue: "overview",
      onValueChange: handleOnChange,
      value: currentTab || "overview"
    },
    /* @__PURE__ */ React8.createElement(Tabs.TabList, { tabDistribution: "hugContents", divider: true }, tabs.map((tab, index) => {
      if (!isDashboardEnabled && tabs[index] === "metrics") {
        return null;
      }
      if (!isAchievementsEnabled && tabs[index] === "achievements") {
        return null;
      }
      return /* @__PURE__ */ React8.createElement(StyledTab, { value: tab, name: tab }, tabMessages(tab));
    })),
    /* @__PURE__ */ React8.createElement(Tabs.TabPanel, { value: "overview" }, /* @__PURE__ */ React8.createElement(AboutMeOverview, null)),
    isDashboardEnabled && /* @__PURE__ */ React8.createElement(Tabs.TabPanel, { value: "metrics" }, /* @__PURE__ */ React8.createElement(AllInsights, null)),
    isAchievementsEnabled && /* @__PURE__ */ React8.createElement(Tabs.TabPanel, { value: "achievements" }, /* @__PURE__ */ React8.createElement(
      UserAchievements,
      {
        errorComponent: /* @__PURE__ */ React8.createElement(
          ErrorPanel,
          {
            error,
            isRefetching: userAchievementsIsRefetching,
            onRetry: () => refetch()
          }
        )
      }
    ))
  ));
}
function AboutMeLandingPage() {
  var _a;
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: "ABOUT_ME" }));
  const { state } = useLocation();
  const [displayUnavailableOnWebModal, setDisplayUnavailableOnWebModal] = React8.useState((_a = state == null ? void 0 : state.showAppsAndDevicesModal) != null ? _a : false);
  const {
    showAccountBanner,
    showOptionsMenu,
    showLandingPageBackButton,
    disableDevicesInMoreOptionsMenu
  } = useAboutMeConfig();
  const backButtonRoute = showLandingPageBackButton ? getModulePath(LEAGUE_MODULE_NAMES.healthJourney) : void 0;
  const showRewardsSidebarCard = useShouldShowRewardsSidebarCard();
  const showSidebar = showRewardsSidebarCard || showOptionsMenu;
  return /* @__PURE__ */ React8.createElement(React8.Fragment, null, /* @__PURE__ */ React8.createElement(
    HealthProfilePageWrapper,
    {
      hideBackButton: !showLandingPageBackButton,
      backButtonRoute,
      title: formatMessage({
        id: "ABOUT_ME"
      }),
      sidebar: showSidebar ? /* @__PURE__ */ React8.createElement(Sidebar, { className: "about-me-sidebar" }, /* @__PURE__ */ React8.createElement(RewardsSidebarCard, null), showOptionsMenu ? /* @__PURE__ */ React8.createElement(MoreOptionsCard, null, disableDevicesInMoreOptionsMenu ? null : /* @__PURE__ */ React8.createElement(
        AddAppsDevicesLink,
        {
          onClick: () => trackAnalyticsEvent2(EVENT_NAME2.BUTTON_CLICKED, {
            product_area: "about me" /* ABOUT_ME */,
            screen_name: "more options menu" /* MORE_OPTIONS_MENU */,
            detail: "view apps and devices"
          })
        }
      ), /* @__PURE__ */ React8.createElement(
        ManageUnitsLink,
        {
          onClick: () => trackAnalyticsEvent2(EVENT_NAME2.BUTTON_CLICKED, {
            product_area: "about me" /* ABOUT_ME */,
            screen_name: "more options menu" /* MORE_OPTIONS_MENU */,
            detail: "change units of measurement"
          }),
          modalScreenLoadedEvent: () => trackAnalyticsEvent2(EVENT_NAME2.SCREEN_LOADED, {
            product_area: "about me" /* ABOUT_ME */,
            screen_name: "change units of measurement" /* CHANGE_UNITS_OF_MEASUREMENT */
          })
        }
      )) : null) : null
    },
    showAccountBanner ? /* @__PURE__ */ React8.createElement(AccountBanner, null) : null,
    /* @__PURE__ */ React8.createElement(NavigationTabs, null)
  ), displayUnavailableOnWebModal ? /* @__PURE__ */ React8.createElement(
    UnavailableDeviceConnectModal,
    {
      onClose: () => setDisplayUnavailableOnWebModal(false)
    }
  ) : null);
}

// src/about-me.routes.tsx
import {
  DashboardRoutes,
  useIsDashboardEnabled as useIsDashboardEnabled2
} from "@leagueplatform/dashboard";

// src/pages/health-report-page/health-report-page.tsx
import Masonry2 from "@leagueplatform/masonry";
import { SCREEN_NAMES, usePageViewAnalytics } from "@leagueplatform/analytics";
import React9 from "react";
import { useDocumentTitle as useDocumentTitle2 } from "@leagueplatform/web-common";
import { useIntl as useIntl2 } from "@leagueplatform/locales";
import {
  BackButtonArrow,
  MainPageContainer
} from "@leagueplatform/web-common-components";
import {
  HeadingText,
  StackItem,
  StackLayout as StackLayout3
} from "@leagueplatform/genesis-core";
import {
  LinkLegacy as Link2,
  useNavigateLegacy as useNavigate2
} from "@leagueplatform/routing";
var HealthReportPage = () => {
  const { formatMessage } = useIntl2();
  const navigate = useNavigate2();
  useDocumentTitle2(formatMessage({ id: "ABOUT_ME" }));
  usePageViewAnalytics({ screen_name: SCREEN_NAMES.HEALTH_REPORT_PAGE });
  useDocumentTitle2(formatMessage({ id: "HEALTH_REPORT_PAGE_HEADING" }));
  const { healthReportMasonryId = HEALTH_REPORT_APP_ID } = useAboutMeConfig();
  const HealthReportMasonry = Masonry2.init({
    appId: healthReportMasonryId,
    analytics: {
      productArea: SCREEN_NAMES.HEALTH_REPORT_PAGE,
      screenName: SCREEN_NAMES.HEALTH_REPORT_PAGE
    },
    apiVersion: ABOUT_ME_MASONRY_API_VERSION
  });
  return /* @__PURE__ */ React9.createElement(MainPageContainer, null, /* @__PURE__ */ React9.createElement(
    StackLayout3,
    {
      orientation: {
        "@initial": "vertical",
        "@laptop": "horizontal",
        "@desktop": "horizontal"
      }
    },
    /* @__PURE__ */ React9.createElement(StackItem, { css: { alignSelf: "start" } }, /* @__PURE__ */ React9.createElement(
      BackButtonArrow,
      {
        as: Link2,
        to: "#",
        marginY: "one",
        marginInlineEnd: "one",
        onClick: (event) => {
          event.preventDefault();
          navigate(-1);
        }
      }
    )),
    /* @__PURE__ */ React9.createElement(
      StackLayout3,
      {
        spacing: "$one",
        horizontalAlignment: "center",
        css: {
          "@laptop": { paddingInlineEnd: "$three" },
          "@desktop": { paddingInlineEnd: "$three" }
        }
      },
      /* @__PURE__ */ React9.createElement(HeadingText, { size: "xxl", level: "1" }, formatMessage({ id: "HEALTH_REPORT_PAGE_HEADING" })),
      /* @__PURE__ */ React9.createElement(HealthReportMasonry.Provider, null)
    )
  ));
};

// src/about-me.routes.tsx
var AboutMeRoutes = () => {
  const { isDashboardEnabled } = useIsDashboardEnabled2();
  return /* @__PURE__ */ React10.createElement(Routes, null, /* @__PURE__ */ React10.createElement(
    Route,
    {
      path: "apps-and-devices/*",
      element: /* @__PURE__ */ React10.createElement(
        Navigate,
        {
          to: { pathname: ".." },
          state: { showAppsAndDevicesModal: true },
          replace: true
        }
      )
    }
  ), /* @__PURE__ */ React10.createElement(Route, { index: true, element: /* @__PURE__ */ React10.createElement(AboutMeLandingPage, null) }), isDashboardEnabled ? /* @__PURE__ */ React10.createElement(Route, { path: "insights/*", element: /* @__PURE__ */ React10.createElement(DashboardRoutes, null) }) : null, /* @__PURE__ */ React10.createElement(Route, { path: "hra-report/*", element: /* @__PURE__ */ React10.createElement(HealthReportPage, null) }));
};

// src/components/view-my-health-dashboard-button/view-my-health-dashboard-button.component.tsx
import React11 from "react";
import { useIntl as useIntl3 } from "@leagueplatform/locales";
import { LinkLegacy as Link3 } from "@leagueplatform/routing";
import { LEAGUE_MODULE_NAMES as LEAGUE_MODULE_NAMES2, getModulePath as getModulePath2 } from "@leagueplatform/core";
import {
  Box as Box3,
  Icon,
  StackLayout as StackLayout4,
  UtilityText,
  Card,
  useClickableCard,
  TextAction,
  queryHelpers,
  useMediaQuery
} from "@leagueplatform/genesis-core";
import { handleStaticAsset as handleStaticAsset2 } from "@leagueplatform/asset-config";
var ViewMyHealthDashboardButton = ({
  handleClickAnalytics
}) => {
  const { formatMessage } = useIntl3();
  const isMobile = useMediaQuery(queryHelpers.only("mobile"));
  const { primaryActionRef, clickAreaRef, onCardMouseDown, onCardMouseUp } = useClickableCard();
  const icon = handleStaticAsset2(
    "ABOUT_ME_VIEW_MY_HEALTH_DASHBOARD_BUTTON_ICON" /* ABOUT_ME_VIEW_MY_HEALTH_DASHBOARD_BUTTON_ICON */
  );
  return /* @__PURE__ */ React11.createElement(Card.Elevated, { imagePosition: { "@initial": "start" }, css: { border: 0 } }, /* @__PURE__ */ React11.createElement(
    Card.ClickArea,
    {
      ref: clickAreaRef,
      onCardMouseUp,
      onCardMouseDown
    },
    /* @__PURE__ */ React11.createElement(Card.Section, { css: { padding: 0 } }, /* @__PURE__ */ React11.createElement(
      StackLayout4,
      {
        orientation: "horizontal",
        horizontalAlignment: "spaceBetween",
        verticalAlignment: "center"
      },
      !isMobile && /* @__PURE__ */ React11.createElement(
        Box3,
        {
          css: {
            backgroundColor: "$interactiveActionPrimary",
            padding: "$one"
          }
        },
        /* @__PURE__ */ React11.createElement(Icon, { icon, size: "32", css: { display: "block" } })
      ),
      /* @__PURE__ */ React11.createElement(
        StackLayout4,
        {
          spacing: "$quarter",
          css: { padding: "$half $none $half $one" }
        },
        /* @__PURE__ */ React11.createElement(
          TextAction,
          {
            as: Link3,
            to: getModulePath2(LEAGUE_MODULE_NAMES2.aboutMe),
            ref: primaryActionRef,
            onClick: () => handleClickAnalytics("view my progress")
          },
          formatMessage({ id: "VIEW_MY_HEALTH_DASHBOARD" })
        ),
        /* @__PURE__ */ React11.createElement(UtilityText, { size: "xs", emphasis: "subtle" }, formatMessage({ id: "LATEST_INSIGHTS_METRICS_AND_MORE" }))
      ),
      /* @__PURE__ */ React11.createElement(Box3, { css: { padding: "$one" } }, /* @__PURE__ */ React11.createElement(
        Icon,
        {
          icon: "interfaceChevronForward",
          size: 22,
          tint: "$onSurfaceIconPrimary"
        }
      ))
    ))
  ));
};

// src/index.ts
initModule();
initMasonryRegistry();
export {
  AboutMeRoutes,
  ViewMyHealthDashboardButton,
  useIsAboutMeEnabled
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/about-me'] = window.leagueSDKsPresent['@leagueplatform/about-me'] || [];
    window.leagueSDKsPresent['@leagueplatform/about-me'].push('2.25.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/about-me'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/about-me module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map